import {PUBLISHED, UNPUBLISHED} from '@/utils/constants/jobs';

export default {
  recommendedJobsLoadingState(state) {
    return state.loading;
  },
  recommendedPublishedJobsListState(state) {
    return state[PUBLISHED];
  },
  recommendedUnpublishedJobsListState(state) {
    return state[UNPUBLISHED];
  },
  amountOfRecommendedJobs(state) {
    return state[PUBLISHED].length + state[UNPUBLISHED].length;
  },
  recommendedJobsErrorState(state) {
    return state.error;
  },
  recommendedPublishedJobByCodeState(state) {
    let jobs = {};
    state[PUBLISHED].forEach(item => {
      jobs[item.job_code] = item;
    });

    return jobs;
  },
  isSomePublishedRecommendedJobNeedReview(state) {
    return state[PUBLISHED].filter(job => job.need_review).length > 0;
  }
};
